import MUIDataTable from 'mui-datatables';
import React from 'react'
import { useEffect } from 'react';
import { FaEdit } from 'react-icons/fa';
import { MdOutlineDeleteOutline } from 'react-icons/md';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import Toggle from 'react-toggle';
import { getModelyearListing , updateModelYear,DeleteCarModelYear} from '../../../actions/homeAction';

const CarModel = () => {

	const dispatch = useDispatch()

	useEffect(() => {
		dispatch(getModelyearListing())
	},[])

	const modelYearList = useSelector(state => state.home.modelYearList)?.response
	console.log("modelYearList", modelYearList);

	const handleStatusChange = (Id,active)=>{
		var data ={
			modelYearId: Id,
			active : !active
		}
		dispatch(updateModelYear(data))
	}
	const HandleDelete = ( ID )=>{
		if(ID){
		dispatch(DeleteCarModelYear(ID))
		}
	}

  const carModelList = []
  let columns = [];

		columns = [
			{
				name: 'modelYear',
				label: 'Model Year Name',
				options: {
					filter: false,
					sort: true,
				},
			},
			{
				name: 'modelYearAr',
				label: 'Model Year Name Ar',
				options: {
					filter: false,
					sort: true,
				},
			},
			{
				name: 'priority',
				label: 'Priority',
				options: {
					filter: false,
					sort: true,
				},
			},
			{
				name: 'active',
				label: 'Status',
				options: {
					filter: true,
					sort: true,
					customBodyRender: (active, tableMeta) => {
						var Id = tableMeta.rowData[2];
						return (
							<Toggle
								id={'status_' + Id}
								defaultChecked={active}
								value={active}
								onChange={()=>handleStatusChange(Id, active)}
							/>
						);
					},
				},
			},
			{
				name: 'modelYearId',
				label: 'Action',
				options: {
					filter: true,
					sort: true,
					customBodyRender: (modelYearId) => {
						return (
							<div>
								<Link to={`/CarDetail/ModelYear/Update/${modelYearId}?`}><FaEdit style={{fontSize: '1.4rem'}} /></Link>
								<span className='delBTN' onClick={()=>HandleDelete(modelYearId)}><MdOutlineDeleteOutline style={{fontSize: '1.4rem', marginLeft:"1rem"}} /></span>
							</div>
						);
					},
				},
			},

		];
    
		const options = {
			filter: false,
			viewColumns: false,
			print: false,
			download: false,
			selectableRows: 'none',
			textLabels: {
				body: {
					// noMatch: this.state.isSaving
					// 	? 'Loading data..!'
					// 	: 'Sorry, No Users Found',
					toolTip: 'Sort',
					columnHeaderTooltip: column => `Sort for ${column.label}`,
				},
			},
		};
  return (
    <div className='pcoded-inner-content'>
				<div className='main-body'>
					<div className='page-wrapper'>
						<div className='row'>
							<div className='col-sm-12'>
								<div className='card'>
									<div className='card-header'>
										<Link
											to={`/CarDetail/ModelYear/Add`}
											className='btn btn-sm btn-inverse waves-effect waves-light f-right d-inline-block md-trigger'
											data-modal='modal-13'>
											{' '}
											<i className='icofont icofont-plus m-r-5'></i>
											Add Model Year
										</Link>
									</div>

									<div className='card-block'>
										<div className='dt-responsive table-responsive'>
											{carModelList !== undefined ? (
												<MUIDataTable
													title={`Model Year`}
													className='table-responsive'
													data={modelYearList}
													columns={columns}
													options={options}
												/>
											) : (
												<h4>Loading...</h4>
											)}
											{/* </MuiThemeProvider> */}
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
  )
}

export default CarModel